import React from "react"
import { EJobDashboardCircleChartType, IJobDashboardChartData, IDate } from "../../../../models"
import strings from "../../../../localization/strings"
import ReactEcharts from "echarts-for-react"
interface IProps {
    loading: boolean
    isToday: boolean
    showCircleChartItems: EJobDashboardCircleChartType[]
    chartData: IJobDashboardChartData
}

const JobDashboardCharts: React.SFC<IProps> = (props: IProps) => {
    const phaseData = props.loading ?
        [{ name: "empty", value: 0 }] :
        props.chartData.Phases.length === 0 ?
            [{ name: "empty", value: 0 }] :
            props.chartData.Phases.map(i => {
                return { name: i.PhaseId ? i.PhaseName : strings.No_Phase, value: i.Count }
            })
    const positionData = props.loading ?
        [{ name: "empty", value: 0 }] :
        props.chartData.Positions.length === 0 ?
            [{ name: "empty", value: 0 }] :
            props.chartData.Positions.map(i => {
                return { name: i.PositionId ? i.PositionName : strings.No_Position, value: i.Count }
            })
    return (
        <div style={{ display: "flex", justifyContent: "center", padding: 15 }}>
            {props.showCircleChartItems.includes(EJobDashboardCircleChartType.Hours) &&
                <PieChart
                    data={[{ name: "empty", value: 0 }]}
                    titleCount={props.loading ? strings.loading : props.chartData.Hours.toString()}
                    titleLabel={strings.Hours}
                    bottomLabel={strings.Hours}
                />
            }
            {props.showCircleChartItems.includes(EJobDashboardCircleChartType.Employees) &&
                <PieChart
                    data={[{ name: "empty", value: 0 }]}
                    titleCount={props.loading ? strings.loading : props.chartData.Employees.toString()}
                    titleLabel={strings.Employees}
                    bottomLabel={props.isToday ? strings.Currently_Working : strings.Worked}
                />
            }
            {props.showCircleChartItems.includes(EJobDashboardCircleChartType.Phases) &&
                <PieChart
                    data={phaseData}
                    titleCount={props.loading ? strings.loading : props.chartData.Phases.filter(i => i.PhaseId ? true : false).length.toString()}
                    titleLabel={strings.Phases}
                    bottomLabel={strings.Job_Phases}
                />
            }
            {props.showCircleChartItems.includes(EJobDashboardCircleChartType.Positions) &&
                <PieChart
                    data={positionData}
                    titleCount={props.loading ? strings.loading : props.chartData.Positions.filter(i => i.PositionId ? true : false).length.toString()}
                    titleLabel={strings.Positions}
                    bottomLabel={strings.Positions}
                />
            }
        </div>
    )
}

export default JobDashboardCharts

interface IChartProps {
    data: any[]
    titleCount: string
    titleLabel: string
    bottomLabel: string
}

const PieChart: React.SFC<IChartProps> = (props: IChartProps) => {
    const option = {
        title: {
            text: props.titleCount,
            textStyle: { fontSize: 20, fontWeight: "bold" },
            subtext: props.titleLabel,
            left: "center",
            top: "middle",
            itemGap: 5
        },
        tooltip: {
            formatter: (params) => {
                return params.data.name === "empty" ? "" : `${params.data.name}: ${params.data.value}`
            }
        },
        series: [
            {
                type: 'pie',
                radius: ['60%', '80%'],
                hoverAnimation: true,
                hoverOffset: 2,
                label: {
                    show: false,
                    position: 'inside'
                },
                data: props.data
            }
        ]
    }

    return (
        <div style={{ width: 150, height: 150, marginTop: -15, marginLeft: 50, marginRight: 50 }}>
            <ReactEcharts style={{ width: "100%", height: "100%" }} option={option} />
            <div style={{ textAlign: "center", marginTop: -5, fontWeight: 500, fontSize: 16 }}>{props.bottomLabel}</div>
        </div>
    )
}

